import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import { store } from "./store.js";
import { BootstrapVue } from "bootstrap-vue";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import apiCall from "@/services/api/apicall";
import VueSweetalert2 from "vue-sweetalert2"; //Vue Popup

Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(VueSweetalert2); //Vue Popup

Vue.prototype.apiURL = "https://www.inspirediagnostics.app/"; //For Mobile browser Production
// Vue.prototype.apiURL = 'http://localhost:8080/';
//Vue.prototype.apiURL = "http://3.14.103.48:8080/"; //For Test env
// Vue.prototype.apiURL = "http://3.23.76.251:8080/"; //For Mobile app Production
// Vue.prototype.apiURL= "https://www.inspirediagnostics.stag/"; //For Staging

axios.defaults.baseURL = Vue.prototype.apiURL.concat("api/");

const init = () => {
  new Vue({
    router,
    data() {
      return {
        store: store,
      };
    },
    render: h => h(App),
  }).$mount("#app");
};

// Wait for the deviceready event to start the render
document.addEventListener("deviceready", () => {
  console.log("device ready called");
  // window.localStorage.setItem("mobileToken", "false");
  // eslint-disable-next-line
  init();
});

// If we are not in Cordova, manually trigger the deviceready event
const isCordovaApp = typeof window.cordova !== "undefined";
if (!isCordovaApp) {
  document.dispatchEvent(new CustomEvent("deviceready", {}));
}


Vue.mixin({
  methods: {
    signout() {
      // window.localStorage.removeItem("LI3EIB");//Email
      // window.localStorage.removeItem("QW3F4OV6");//Password
      // window.localStorage.removeItem("token");
      this.sendToken();
      this.$router.push({ path: "/login" });
    },   
    sendToken() {
      let header = {
        headers: [
          {
            key: "Content-Type",
            value: "application/json",
            type: "text",
          },
        ],
      };
      apiCall
        .apiServiceCall("Post", "", "/nfc", " ", header)
        .then(response => {
          
            if (response.data.status == 1) {
              // console.log("Token Removed");
              window.localStorage.setItem("mobileToken", "false");
            }
        })
        .catch(error => {
          if (error.response.status == 401) {
            // setTimeout(() => this.$router.push({ path: "/home" }), 2000);
          } else {
          console.log(error);
          }
        });
    },
  }
})

// Constants
Vue.prototype.whatsnew = "What's New";
Vue.prototype.nextScheduledTest = "Next Scheduled Test";
Vue.prototype.scheduleTestTitle = "Fill-in the details to schedule a Test";
Vue.prototype.appointmentDetails = "Appointment Details";
Vue.prototype.datetimelabel = "Date/Time :";
Vue.prototype.locationlabel = "Location :";
Vue.prototype.changeApptTitle = "CHANGE APPOINTMENT";
Vue.prototype.clear = "CLEAR";
Vue.prototype.cancel = "CANCEL";
Vue.prototype.noTestFacilityAvailable = "There is no Test Facility available for the selected Date";
Vue.prototype.selectAllFields = "Please select Date, Location and Time slot to fix schedule";
Vue.prototype.disclaimerTitle = "Disclaimer";
Vue.prototype.personalDetailTitle = "Personal Details";
Vue.prototype.maritalStatus = "Marital Status";
Vue.prototype.otpResendText = "Didn't get code? ";
Vue.prototype.otpResendCode = "Resend";
Vue.prototype.premedical = "Are you under treatment for any of the following conditions?";
Vue.prototype.selectManyOptions = "Select as many that apply";
Vue.prototype.premedicalTitle = "Pre - Existing Medical Details";
Vue.prototype.premedicalPopup = "If you have no pre-medical conditions, please select 'None of the above' option and submit";
Vue.prototype.mobilenumberformat = "* Include Country Code (e.g. 13015551212) ";
Vue.prototype.passwordFormat =
  "Password should have minimum of 8 characters, at least one upper case character, 1 special character and 1 number";
Vue.prototype.resourcesTitle = "Frequently Asked Questions";
Vue.prototype.healthSurvey = "Are you experiencing new or worsening onset of any of the following symptoms?";
Vue.prototype.healthSurveySubText = "Stop and call 911 if you are experiencing:";
Vue.prototype.healthSurveyList1 = "Severe, constant chest pain or pressure";
Vue.prototype.healthSurveyList2 = "Extreme difficulty breathing";
Vue.prototype.healthSurveyList3 = "Severe, constant lightheadedness";
Vue.prototype.healthSurveyList4 = "Serious disorientation or unresponsiveness";
Vue.prototype.healthSurveyBackPopup = "Do you want to leave Health Survey page, without submitting the Survey today.";
Vue.prototype.healthSurveyNoSymptomPopup = "If you have no symptoms, please select 'No Symptom' option and submit";
Vue.prototype.healthSurveyCDCURL = "https://www.cdc.gov/coronavirus/2019-ncov/symptoms-testing/symptoms.html";
Vue.prototype.testDate = "Test Date";
Vue.prototype.testName = "Test Name";
Vue.prototype.testResultTitle = "Result";
Vue.prototype.howToReadResult = "How to read Test Results";
Vue.prototype.cancelApptTitle = "CANCEL APPOINTMENT";
Vue.prototype.cancelApptPopup = "Do you want to cancel your test appointment?";
Vue.prototype.ok = "OK";
Vue.prototype.continue = "CONTINUE";
Vue.prototype.goLogin = "GO LOGIN";
Vue.prototype.yes = "YES";
Vue.prototype.no = "NO";
Vue.prototype.checkInternetConnection = "Please check your Internet Connection";
Vue.prototype.serverProblem = "Server problem. Please contact Admin";
Vue.prototype.noTestResults = "No Test Results";
//TODO
// Vue.prototype.otpMsg = "An OTP has been sent to your Email Address/Cell Phone. Please press back button to change the Email Address/cell phone number";
Vue.prototype.otpMsg = "An OTP has been sent to your Email Address.  You can press the back button to enter a different Email Address.";
Vue.prototype.back = "BACK";
Vue.prototype.cancel = "CANCEL";
